import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../public/menu.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-02459976"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "viewer-container" }
const _hoisted_2 = { class: "btn" }
const _hoisted_3 = { "data-tooltip": "Menu" }
const _hoisted_4 = { id: "filterFrame" }
const _hoisted_5 = { class: "d-flex" }

import '@google/model-viewer';
import '@google/model-viewer-effects';
import { VCheckbox } from 'vuetify/components';


import {onMounted, ref} from "vue";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import * as PostProcessing from "postprocessing";



export default /*#__PURE__*/_defineComponent({
  __name: 'MainView',
  setup(__props) {

const store = useStore();
const router = useRouter();

const shadowIntensity =  ref(0);
const shadowSoftness =  ref(0);
const isSkyBoxImage =  ref(0);
const isEnvImage =  ref(0);
const brightness =  ref(0);
const contrast =  ref(0);
const opacity =  ref(1);
const pixar =  ref(0);
const grid =  ref(0);
const sepia =  ref(0);
const showIsCopiedLink =  ref(false);
const menu =  ref(false);
const tab =  ref('one');
const blendMode =  ref('skip');

// Initialize PostProcessing effects
let gridEffect: PostProcessing.GridEffect | null = null;
let sepiaEffect: PostProcessing.SepiaEffect | null = null;

function makeLink(): string {
  // return `<iframe src="http://localhost/model/${this.MAIN_MODEL_ID}?shadowIntensity=${this.shadowIntensity}&brightness=${this.brightness}&contrast=${this.contrast}&opacity=${this.opacity}&blendMode=${this.blendMode}&blockOpacity=${this.blockOpacity}&pixar=${Number(this.pixar)}&isEnvImage=${Number(this.isEnvImage)}&isSkyBoxImage=${Number(this.isSkyBoxImage)}"></iframe>`
  return `<iframe src="https://modelviewer.pl/model/${store.getters.MAIN_MODEL_ID}?grid=${grid.value}&sepia=${sepia.value}&shadowIntensity=${shadowIntensity.value}&brightness=${brightness.value}&contrast=${contrast.value}&opacity=${opacity.value}&blendMode=${blendMode.value}&blockOpacity=${opacity.value}&pixar=${Number(pixar)}&isEnvImage=${Number(isEnvImage.value)}&isSkyBoxImage=${Number(isSkyBoxImage.value)}"></iframe>`
}
function copyLink(): void {
  navigator.clipboard.writeText(makeLink());
  showIsCopiedLink.value = true;
}
function goToLogin(): void {
  router.push({ name: "login" });
}

function changeSepia(): void {
  const customComposer = document.querySelector('effect-composer#customComposer') as any;
  sepiaEffect.setIntensity(sepia.value)
  customComposer.queueRender()

}

function changeGrid(): void {
  if (!gridEffect) {
    console.error('GridEffect is not initialized');
    return;
  }

  gridEffect.scale = grid.value;

  const customComposer = document.querySelector('effect-composer#customComposer') as any;
  if (!customComposer) {
    console.error('EffectComposer not found');
    return;
  }

  customComposer.queueRender();
}

// Setup PostProcessing on mount
onMounted(() => {
  const customComposer = document.querySelector('effect-composer#customComposer') as any;
  if (!customComposer) {
    console.error('EffectComposer not found');
    return;
  }

  gridEffect = new PostProcessing.GridEffect({scale: 0});
  sepiaEffect = new PostProcessing.SepiaEffect();
  sepiaEffect.intensity = 0;
  const noisePass = new PostProcessing.EffectPass(undefined, gridEffect, sepiaEffect);
  customComposer.addPass(noisePass);
});

return (_ctx: any,_cache: any) => {
  const _component_pixelate_effect = _resolveComponent("pixelate-effect")!
  const _component_color_grade_effect = _resolveComponent("color-grade-effect")!
  const _component_effect_composer = _resolveComponent("effect-composer")!
  const _component_model_viewer = _resolveComponent("model-viewer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_slider = _resolveComponent("v-slider")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_model_viewer, {
        src: _unref(store).getters.MAIN_MODEL,
        "skybox-image": _unref(store).getters.MAIN_SKY_BOX_IMAGE,
        "environment-image": _unref(store).getters.MAIN_ENV_IMAGE,
        "shadow-intensity": shadowIntensity.value,
        "shadow-softness": shadowSoftness.value,
        "camera-controls": "",
        "touch-action": "pan-y",
        id: _unref(store).getters.MAIN_MODEL
      }, {
        default: _withCtx(() => [
          _createVNode(_component_effect_composer, {
            id: "customComposer",
            "render-mode": "quality",
            msaa: "8"
          }, {
            default: _withCtx(() => [
              (pixar.value)
                ? (_openBlock(), _createBlock(_component_pixelate_effect, { key: 0 }))
                : _createCommentVNode("", true),
              _createVNode(_component_color_grade_effect, {
                contrast: contrast.value,
                saturation: "-1",
                opacity: opacity.value,
                "blend-mode": blendMode.value,
                brightness: brightness.value
              }, null, 8, ["contrast", "opacity", "blend-mode", "brightness"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["src", "skybox-image", "environment-image", "shadow-intensity", "shadow-softness", "id"])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_v_menu, {
          modelValue: menu.value,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((menu).value = $event)),
          "close-on-content-click": false,
          location: "center",
          "max-width": "350"
        }, {
          activator: _withCtx(({ props }) => [
            _createElementVNode("p", _hoisted_3, [
              _createElementVNode("img", _mergeProps({
                height: "30",
                width: "30"
              }, props, {
                class: "changePointer",
                src: _imports_0
              }), null, 16)
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              "min-width": "300",
              color: "black",
              style: _normalizeStyle([{ opacity: _ctx.blockOpacity }, {"border-radius":"20px"}])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_tabs, {
                      "align-tabs": "left",
                      modelValue: tab.value,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((tab).value = $event)),
                      "bg-color": "black"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("a", {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (menu.value=false)),
                          style: {"cursor":"pointer","width":"70px"}
                        }, [
                          _createVNode(_component_v_tab, {
                            disabled: "",
                            style: {"opacity":"1"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                color: "white",
                                size: "x-large"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" mdi-close ")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _createVNode(_component_v_tab, { value: "one" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Filters")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_tab, { value: "three" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Get code")
                          ]),
                          _: 1
                        }),
                        _createElementVNode("a", {
                          style: {"cursor":"pointer","width":"30px"},
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (goToLogin()))
                        }, [
                          _createVNode(_component_v_tab, { style: {"opacity":"1"} }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                color: "white",
                                size: "x-large"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" mdi-login ")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_v_card_text, { style: {"background-color":"#0e0e0e"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_window, {
                          modelValue: tab.value,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((tab).value = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_window_item, {
                              id: "windowFilter",
                              value: "one"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_4, [
                                  _createVNode(_component_v_row, { class: "color-white" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(VCheckbox), {
                                            label: "Pixel",
                                            modelValue: pixar.value,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((pixar).value = $event))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_slider, {
                                            class: "wd-all",
                                            modelValue: brightness.value,
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((brightness).value = $event)),
                                            label: "Brightness",
                                            color: "orange",
                                            min: "-1",
                                            max: "1",
                                            step: "0.01",
                                            "thumb-label": "true"
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_slider, {
                                            class: "wd-all",
                                            modelValue: opacity.value,
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((opacity).value = $event)),
                                            label: "Opacity",
                                            color: "orange",
                                            min: "0",
                                            max: "1",
                                            step: "0.01",
                                            "thumb-label": "true"
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_slider, {
                                            class: "wd-all",
                                            modelValue: contrast.value,
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((contrast).value = $event)),
                                            label: "Contrast",
                                            color: "orange",
                                            min: "0",
                                            max: "1",
                                            step: "0.01",
                                            "thumb-label": "true"
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_slider, {
                                            class: "wd-all",
                                            modelValue: grid.value,
                                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((grid).value = $event)),
                                            update: changeGrid(),
                                            label: "Grid",
                                            color: "orange",
                                            min: "0",
                                            max: "2",
                                            step: "0.01",
                                            "thumb-label": "true"
                                          }, null, 8, ["modelValue", "update"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_slider, {
                                            class: "wd-all",
                                            modelValue: sepia.value,
                                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((sepia).value = $event)),
                                            update: changeSepia(),
                                            label: "Sepia",
                                            color: "orange",
                                            min: "0",
                                            max: "5",
                                            step: "0.01",
                                            "thumb-label": "true"
                                          }, null, 8, ["modelValue", "update"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_slider, {
                                            modelValue: shadowSoftness.value,
                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((shadowSoftness).value = $event)),
                                            class: "wd-all",
                                            label: "Shadow softness",
                                            color: "orange",
                                            min: "0",
                                            max: "1",
                                            step: "0.01",
                                            "thumb-label": "true"
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_slider, {
                                            class: "wd-all",
                                            modelValue: shadowIntensity.value,
                                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((shadowIntensity).value = $event)),
                                            label: "Shadow intensity",
                                            min: "0",
                                            max: "4",
                                            step: "0.01",
                                            color: "orange",
                                            "thumb-label": "true"
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_select, {
                                            modelValue: blendMode.value,
                                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((blendMode).value = $event)),
                                            items: ['Default', 'Skip', 'Add', 'Subtract', 'Divide', 'Negation'],
                                            variant: "primary"
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_window_item, {
                              value: "three",
                              class: "color-white",
                              style: {"text-align":"justify"}
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_5, [
                                  _createVNode(_unref(VCheckbox), {
                                    label: "Environment image",
                                    modelValue: isEnvImage.value,
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((isEnvImage).value = $event))
                                  }, null, 8, ["modelValue"]),
                                  _createVNode(_unref(VCheckbox), {
                                    label: "Skybox image",
                                    modelValue: isSkyBoxImage.value,
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((isSkyBoxImage).value = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                (showIsCopiedLink.value)
                                  ? (_openBlock(), _createBlock(_component_v_alert, {
                                      key: 0,
                                      class: "mb-5",
                                      text: "The code was copied!",
                                      type: "success"
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_v_textarea, {
                                  label: "",
                                  "prepend-icon": "mdi-content-copy",
                                  value: makeLink(),
                                  variant: "solo-filled",
                                  "onClick:prepend": _cache[14] || (_cache[14] = ($event: any) => (copyLink()))
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["style"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ])
  ]))
}
}

})